export default "__VITE_ASSET__CxMzehCn__"